import React from 'react';
import Button from '../Button/Button';

import './Confirm.scss';

interface IProps {
  message: string | JSX.Element;
  onConfirm: () => void;
  onCancel: () => void;
  buttonsDisabled?: boolean;
  submitting?: boolean;
}

const Confirm: React.FC<IProps> = (props) => {
  return (
    <div className="Confirm">
      <div className="title">Confirm</div>
      <p>{props.message}</p>
      <div className="button-group">
        <Button isLoading={props.submitting} disabled={props.buttonsDisabled ? props.buttonsDisabled : false} onClick={props.onCancel}>Cancel</Button>
        <Button isLoading={props.submitting} disabled={props.buttonsDisabled ? props.buttonsDisabled : false} onClick={props.onConfirm}>Confirm</Button>
      </div>
    </div>
  );
}

export default Confirm;